import React, { memo } from 'react';
export function WhyDifferentSection() {
  return <section className="w-full bg-[#F0EBE3] px-6 py-16 md:py-24 flex justify-center" data-id="element-209">
      <div className="max-w-3xl w-full text-center" data-id="element-210">
        <div className="bg-[#FAF8F5] rounded-2xl p-8 md:p-12 shadow-md border border-[#B8A99A]/20 relative overflow-hidden" data-id="element-211">
          {/* Decorative element */}
          <div className="absolute top-0 left-0 w-full h-1 bg-[#C4887C]/30" data-id="element-212"></div>

          <h2 className="font-['DM_Sans'] text-3xl md:text-4xl font-medium text-[#3A3A3A] mb-6" data-id="element-213">
            Built for memory, not productivity
          </h2>

          <p className="text-lg md:text-xl text-[#3A3A3A]/80 leading-relaxed" data-id="element-214">
            Cardkeeper isn't a card-sending app. It's not a photo dump or a
            contact manager. It's a quiet place to preserve the cards that
            matter—the ones that mark time, celebrate milestones, and remind you
            who's thinking of you.
          </p>
        </div>
      </div>
    </section>;
}